import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { useState } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';

import ConfirmationModal from '~/components/ConfirmationModal';
import commonMessages from '~/containers/App/messages';
import { useTurnCancellation } from '~/hooks/api/useTurnCancellation';
import messages from './messages';

type TurnCancellationButtonProps = {
  turnId: number;
  shiftId: number;
};

const TurnCancellationButton = (props: TurnCancellationButtonProps) => {
  const intl = useIntl();
  const { showSnackbar } = useSnackbar();
  const [isCancellationDialogVisible, setCancellationDialogVisibility] =
    useState(false);
  const [cancellationReason, setCancellationReason] = useState('');
  const cancellationMutation = useTurnCancellation({
    onSuccess() {
      setCancellationDialogVisibility(false);
      showSnackbar({
        message: intl.formatMessage(messages.cancellationSuccess),
      });
    },
    onError() {
      setCancellationDialogVisibility(false);
      showSnackbar({
        message: intl.formatMessage(messages.cancellationFailure),
      });
    },
  });
  return (
    <>
      <Button
        variant="contained"
        color="error"
        onClick={() => setCancellationDialogVisibility(true)}
      >
        {cancellationMutation.isPending ? (
          <FormattedMessage {...commonMessages.loading} />
        ) : (
          <FormattedMessage {...messages.cancelShift} />
        )}
      </Button>
      <ConfirmationModal
        open={isCancellationDialogVisible}
        title={intl.formatMessage(messages.confirmCancellationTitle)}
        text={
          <TextField
            variant="standard"
            id="turn-cancellation-reason"
            onChange={(event) => setCancellationReason(event.target.value)}
            label={intl.formatMessage(messages.cancellationLabel)}
            fullWidth
          />
        }
        confirmLabel={<FormattedMessage {...messages.confirmCancellation} />}
        cancelLabel={<FormattedMessage {...messages.cancelCancellation} />}
        onCancel={() => setCancellationDialogVisibility(false)}
        onConfirm={() => {
          cancellationMutation.mutate({
            turnId: props.turnId,
            cancellationReason,
            shiftId: props.shiftId,
          });
        }}
      />
    </>
  );
};

export default TurnCancellationButton;
